













import { cloneDeep, tap } from 'lodash';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { IFormatParameter, FormatParameter, ICampaign, CampaignParameter, ICampaignParameter } from '@models';
import FormatParameterService from '../../../services/FormatParameterService';
import { Environment } from '../../../helpers/Environment';

@Component
export default class CampaignParametersForm extends Vue {
  name = 'campaign-parameters-form';

  @Prop({ required: true, }) value: ICampaign;

  @Prop({ required: false, }) helpText?: string;

  @Prop({ type: String, default: "" })
  formatversionid: string;

  @Watch("formatversionid")
  async loadFormatParameters() {
    if (this.formatversionid && this.value) {
      const response = await FormatParameterService.getFormatParameters(this.formatversionid);
      if (response.status == 200 || response.status == 201) {
        this.parameters = response.data;
        const missingCampaignParams = this.parameters
          .filter(formatParam => formatParam.isReplaceableValue && typeof (this.value.parameters.find(campaignParam => campaignParam.tag === formatParam.tag)) === 'undefined')
          .map(formatParam => new CampaignParameter({
            id: null,
            campaignId: null,
            formatParameterId: formatParam.id,
            value: formatParam.value,
            tag: formatParam.tag,
            file: null,
            formatParameter: formatParam,
          }));

        this.$emit('input', tap(cloneDeep(this.value), v => v.parameters = v.parameters.concat(missingCampaignParams)));
      }
      else {
        throw new Error("Could not load parameters");
      }
    }
  }

  getLocalCampaignParameterIndex(campaignParameter: ICampaignParameter) {
    let index = this.local.parameters.findIndex(x => x.tag === campaignParameter.tag);
    return index;
  }

  @Watch("value")
  updateAssetsPath() {
    this.environment.GetEnvironmentVariables(["Environment:AssetPath"]).then(
      response => {
        this.assetsPath = response["Environment:AssetPath"];
      }
    )
  }

  assetsPath: string = "";
  environment: Environment = new Environment();

  parameters: Array<IFormatParameter> = new Array<FormatParameter>();

  get local(): ICampaign {
    return this.value;
  }

  get helpTextIdentifier(): string {
    return this.helpText;
  }

  get parameterPairs(): Array<{ campaignParameter: ICampaignParameter, formatParameter: IFormatParameter, index: number }> {
    let result = [] as Array<{ campaignParameter: ICampaignParameter, formatParameter: IFormatParameter, index: number }>;
    let index = 0;

    this.local.parameters.forEach(campaignParameter => {
      let oldIndex = index;
      index++;
      const formatParameter = this.parameters.find(formatParameter => formatParameter.tag === campaignParameter.tag);

      if (!formatParameter || typeof (formatParameter) === 'undefined')
        return;

      result.push({ campaignParameter, formatParameter, index: oldIndex });
    });
    return result.sort(
      (a, b) => {
        if (a.formatParameter.description.toLocaleLowerCase() < b.formatParameter.description.toLocaleLowerCase()) {
          return -1;
        }
        if (a.formatParameter.description.toLocaleLowerCase() > b.formatParameter.description.toLocaleLowerCase()) {
          return 1;
        }
        return 0;
      }
    );
  }

  getFormatParameterByTag(tag: string): IFormatParameter {
    return this.parameters.find(param => param.tag === tag);
  }

  isValidJson(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      console.error(str+" is NOT Valid");
      return false;
    }
    return true;
  }


}
